<script lang="ts" setup>
import { startCase } from 'lodash'

import { ShipmentType } from '@/types/delivery-management'
import { getShipmentTypeBadge } from '@/utils/delivery-management/group-tour-events'
import { shipmentTypes } from '@/utils/delivery-management'

interface Props {
    shipmentType: ShipmentType
}

const props = defineProps<Props>()
</script>

<template>
    <!-- The transform forces the GPU to render the letter inside the badge properly, the leading-none sets the line height makes sure the area around the letter is sized properly when we do the transformation -->
    <span
        v-tooltip="startCase(shipmentTypes[props.shipmentType])"
        class="inline-flex h-4 aspect-square select-none items-center justify-center rounded-full border text-xs border-black text-white bg-black leading-none"
        style="transform: translateY(1px)"
        v-text="getShipmentTypeBadge(props.shipmentType)"
    />
</template>
